import { render, staticRenderFns } from "./handcaozuo.vue?vue&type=template&id=a0324d9a"
import script from "./handcaozuo.vue?vue&type=script&lang=js"
export * from "./handcaozuo.vue?vue&type=script&lang=js"
import style0 from "./handcaozuo.vue?vue&type=style&index=0&id=a0324d9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports